import { createSlice, PayloadAction, createAsyncThunk, createSelector } from '@reduxjs/toolkit';

import { StudentFragment } from '@school_ify/schoolify-repository/src/shared/types';

import ChatService from 'domain/services/chat/ChatServices';

interface StudentFragmentExtended extends StudentFragment {
  active?: boolean;
}
interface DirectMessageInterface {
  id: string;
  user: StudentFragmentExtended;
  unread_messages: number;
}

interface DirectMessageState {
  error: string;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  participants: DirectMessageInterface[];
}

export const fetchUsers = createAsyncThunk('directMessages/fetchUsers', async (userId: string) => {
  try {
    const users = await ChatService.getPossibleParticipants();
    const dataNormilized = users.map(e => {
      const obj = {
        id: e.id,
        user:
          e.participants[0]?.user?.id !== userId
            ? e.participants[0]?.user
            : e.participants[1]?.user,
        unread_messages: e.unread_messages,
      };
      return obj;
    });
    return dataNormilized;
  } catch (error) {
    throw new Error(error);
  }
});

interface UnreadMessageType {
  body: string;
  id: string;
  user_id: string;
  chat_id: string;
}
const initialState = { loading: 'idle', participants: [] } as DirectMessageState;

const directMessagesSlice = createSlice({
  name: 'directMessages',
  initialState,
  reducers: {
    updateUnreadDirrectMessageCount(state, action: PayloadAction<UnreadMessageType>) {
      state.participants.map(e => {
        if (e.id === action.payload.chat_id) {
          e.unread_messages += 1;
        }
        return e;
      });
    },
    markAllMassagesAsRead(state, action: PayloadAction<string>) {
      state.participants = state.participants.map(e => {
        if (e.id === action.payload) {
          e.unread_messages = 0;
        }
        return e;
      });
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchUsers.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.loading = 'success';
      state.participants = [...action.payload];
    });
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const selectDirectMessages = state => state.direct_messages;

export const selectParticipants = createSelector(selectDirectMessages, state => state.participants);
export const selectDirectChats = createSelector(selectDirectMessages, directMessages => {
  return {
    participants: directMessages.participants,
    loading: directMessages.loading,
  };
});
export const { updateUnreadDirrectMessageCount, markAllMassagesAsRead } =
  directMessagesSlice.actions;
export default directMessagesSlice.reducer;
